import { createRouter, createWebHistory } from 'vue-router'
import ThankYou from './views/ThankYou.vue'

import HomePage from './views/Home.vue'

const routes = [
  { path: '/', name: 'Home', component: HomePage },
  { path: '/thank-you', name: 'ThankYou', component: ThankYou },
]


const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
